import { computed } from 'vue';
import { useServiceChargeStore } from '../stores/service-charge.store';
// =============================================================================
// COMPOSABLE
// =============================================================================
export function useServiceCharges() {
    const store = useServiceChargeStore();
    return {
        serviceId: computed(() => store.serviceId),
        attachedTemplateIds: computed(() => store.attachedTemplateIds),
        customCharges: computed(() => store.customCharges),
        isTemplateAttached: computed(() => store.isTemplateAttached),
        isTemplateLoading: computed(() => store.isTemplateLoading),
        isSaving: computed(() => store.isSaving),
        isLoading: computed(() => store.isLoading),
        error: computed(() => store.error),
        initForService: (id) => store.initForService(id),
        attachTemplate: (id) => store.attachTemplate(id),
        detachTemplate: (id) => store.detachTemplate(id),
        addCustomCharge: (dto) => store.addCustomCharge(dto),
        editCustomCharge: (chargeId, dto) => store.editCustomCharge(chargeId, dto),
        removeCustomCharge: (chargeId) => store.removeCustomCharge(chargeId),
        applyPendingCharges: (id) => store.applyPendingCharges(id),
        $reset: () => store.$reset(),
    };
}
export default useServiceCharges;
